
import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop } from "vue-property-decorator";

@Component
export default class InputFile extends Vue {
  @Prop() field!: string;
  @Prop() value!: string;
  @Prop() src!: string;
  @Prop() error!: string;
  @Prop() required!: boolean;
  @Prop({ default: "" }) css!: string;

  url: string = "";
  cleanedName: string | null = null;
  entityValue: File | null = null;

  created() {
    this.url = this.src;
    this.cleanedName = this.field;
    this.entityValue = null;
  }

  @Emit("input")
  setFile(e: Event) {
    const target = e.target as HTMLInputElement;
    const file = target.files?.[0];
    if (!file) return;

    this.cleanedName = file.name;
    this.entityValue = file;
    this.url = URL.createObjectURL(file);
    return file;
  }

  clearFile() {
    const file = document.getElementById(this.field) as HTMLInputElement;
    if (file) file.value = "";
    this.cleanedName = null;
    this.entityValue = null;
    this.$emit("input", null);
  }

  isNull(value: any): boolean {
    return value === null || value === undefined || value === "";
  }
}
